import React from "react";
import { Dumbbell } from "lucide-react";

export function Logo({ size = "md", showText = true }) {
  const dim = size === "lg" ? "h-11 w-11" : size === "sm" ? "h-8 w-8" : "h-9 w-9";
  const text = size === "lg" ? "text-2xl" : "text-lg";
  return (
    <div className="flex items-center gap-2.5" data-testid="app-logo">
      <div className={`${dim} rounded-xl bg-gradient-to-br from-emerald-400 to-sky-500 flex items-center justify-center shadow-lg shadow-emerald-500/20`}>
        <Dumbbell className="h-1/2 w-1/2 text-slate-950" strokeWidth={2.5} />
      </div>
      {showText && (
        <span className={`font-display font-extrabold tracking-tight ${text} text-slate-50`}>
          Mira
        </span>
      )}
    </div>
  );
}
